import React, { Component } from "react";
import {
  Col,
  Button,
  Row,
  InputGroup,
  Input,
  InputGroupAddon,
} from "reactstrap";
import { UserRole } from "./../../../utils/constants";
import * as url from "./../../../utils/url";
import axios from "../../../axios";
import { connect } from "react-redux";
import OfficeMate from "../../office/OfficeMates/OfficeMate/OfficeMate";
import Loading from "../../../hoc/Loading/Loading";
import findIndex from "lodash/findIndex";
import { withRouter } from "react-router";
import EmptyTable from "./../../../components/EmptyTable/EmptyTable";
import { isMobile } from "../../../utils/deviceInfo";
import If from "../../../components/Shared/If";
import { getFlatDataFromTree } from "react-sortable-tree";
import UploadUsersModal from "./UploadUsersModal";

// import './OfficeMates.css';

class UsersList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      officeMates: [],
      searchedTerm: "",
      displayUsers: [],
      allOfficesWithInvitations: [],
    };
  }

  componentDidMount() {
    this.getOfficeMates(this.props.type);

    // this.getAllOffice()
  }

  getAllOffice = () => {
    let { organizationId, role, orgAdmin } = this.props.user;
    let { staticHierarchy } = organizationId;

    if (role === "SuperAdmin" || (orgAdmin && role === "Admin")) {
      const flat = getFlatDataFromTree({
        treeData: staticHierarchy,
        getNodeKey: ({ node }) => node.id,
        ignoreCollapsed: false,
      });
      console.log("flat---", flat);
      const localOfficePaths = flat.map((o) => ({
        name: o.node.title,
        path: o.path.join("#"),
      }));
      const localOfficesWithInvitations = localOfficePaths.map((office) => {
        console.log("p---", office);
        var oName = office.name ? office.name : office.path.split("#").pop();
        return {
          officeHierarchyPath: office.path,
          officeName: oName,
          invitedAdmins: [],
        };
      });
      let allOfficesWithInvitations = localOfficesWithInvitations;
      console.log(localOfficesWithInvitations);
      this.setState({
        allOfficesWithInvitations: allOfficesWithInvitations,
      });
    } else {
      this.setState({
        allOfficesWithInvitations: [],
      });
    }
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.type !== this.props.type) {
      this.getOfficeMates(nextProps.type);
    }
  }

  // Handle role changed
  handleRoleChange = (changeRoleOfficeMate) => {
    console.log(changeRoleOfficeMate, "****");
    let { officeId, officeHierarchyPath, role } = changeRoleOfficeMate;
    let officeMates = [...this.state.officeMates];
    officeMates = officeMates.map((officeMate) => {
      if (officeMate._id === changeRoleOfficeMate._id) {
        if (changeRoleOfficeMate.previousRole === "Member") {
          return {
            ...officeMate,
            role,
            officeId,
            officeHierarchyPath,
            orgAdmin: changeRoleOfficeMate.orgAdmin,
          };
        } else {
          return {
            ...officeMate,
            role: changeRoleOfficeMate.role,
            orgAdmin: changeRoleOfficeMate.orgAdmin,
          };
        }
      } else {
        return officeMate;
      }
    });
    this.setState({ officeMates: officeMates, displayUsers: officeMates });
  };

  handleOfficeChange = (user) => {
    console.log("props office change---");
    console.log(user, user._id, user.officeId);
    let { officeHierarchyPath, officeId } = user;
    let officeMates = [...this.state.officeMates];
    officeMates = officeMates.map((officeMate) => {
      if (officeMate._id === user._id) {
        return { ...officeMate, officeId, officeHierarchyPath };
      } else {
        return officeMate;
      }
    });
    this.setState({ officeMates: officeMates, displayUsers: officeMates });
  };

  // Handle user removed
  handleUserRemoved = (id) => {
    let officeMates = [...this.state.officeMates];
    const i = findIndex(officeMates, (officeMate) => {
      return officeMate._id === id;
    });
    if (i > -1) {
      officeMates.splice(i, 1);
    }
    this.setState({ officeMates: officeMates, displayUsers: officeMates });
  };

  // Get Office Mates
  getOfficeMates = (val) => {
    console.log("axios---", val);

    axios
      .get(url.fetchUsers)
      .then((response) => {
        console.log(response.data.data);
        if (val == "all") {
          this.setState({
            officeMates: response.data.data,
            displayUsers: response.data.data,
          });
        }
        this.props.getUserCount(response.data.data.length);
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(url.getOfficeMates)
      .then((response) => {
        // console.log(response.data.data )
        if (val !== "all") {
          this.setState({
            officeMates: response.data.data,
            displayUsers: response.data.data,
          });
        }
        console.log(response.data.data.length);
        this.props.getOfficeCount(response.data.data.length);
      })
      .catch((error) => {
        console.log(error);
      });

    // if(val==="all"){
    //     axios.get(url.fetchUsers).then((response) => {
    //         // console.log(response.data)
    //         this.setState({ officeMates: response.data.data, displayUsers:response.data.data });
    //         // console.log(response.data.data.length)
    //         this.props.getUserCount(response.data.data.length)
    //     }).catch((error) => {
    //         console.log(error);
    //     })
    // }else {
    //     axios.get(url.getOfficeMates).then((response) => {
    //         // console.log(response.data.data )
    //         this.setState({ officeMates: response.data.data , displayUsers:response.data.data});
    //         this.props.getOfficeCount(response.data.data.length)
    //     }).catch((error) => {
    //         console.log(error);
    //     })
    // }
  };

  goToInviteOfficeMates = () => {
    // console.log(this.props.history)
    // this.props.history.push('/home/office/invite-office-mates');
    this.props.history.push("/home/users/invite");
  };

  handleSearchQueryChanged = ({ target }) => {
    let { value } = target;
    // console.log(value)
    // this.state.officeMates
    let { officeMates } = this.state;
    // value = value.replace(/\s/g,'')
    let list = [];
    // console.log
    if (value.length === 0) {
      list = officeMates;
    } else {
      list = officeMates.filter((user) => {
        let fname = user.firstName ? user.firstName : "";
        let lname = user.lastName ? user.lastName : "";
        let role = user.role ? user.role : "";
        let title = user.title ? user.title : "";
        let name = fname + " " + lname + user.email + role + title;
        // console.log(name)
        if (name.toLowerCase().includes(value.toLowerCase())) {
          return user;
        }
      });
      //   list = filter(officeMates,(user) => user.firstName.toLowerCase().includes(value.toLowerCase()) );
    }

    this.setState({
      displayUsers: list,
      searchedTerm: value,
    });
  };

  render() {
    let { searchedTerm, allOfficesWithInvitations } = this.state;
    const { uploadUsersModal, setUploadUsersModal } = this.props;
    return (
      <div>
        {uploadUsersModal && (
          <UploadUsersModal
            open={uploadUsersModal}
            onClose={() => setUploadUsersModal(false)}
            oldUsers={this.state.officeMates}
            uploadSuccess={() => {
              this.getOfficeMates(this.props.type);
              setUploadUsersModal(false)
            }}
          />
        )}
        <Row className="mt30 mlmr0">
          <Col sm={6}>
            <span className="officemate-title">
              <InputGroup style={{ height: "40px" }}>
                <Input
                  className="toolkit-field tool-search-box"
                  placeholder="Search..."
                  autoComplete={"off"}
                  onChange={this.handleSearchQueryChanged}
                  value={searchedTerm}
                />
                <InputGroupAddon addonType="append">
                  <Button
                    className="color-DADADA border-color-C3C4C7"
                    style={{ height: isMobile ? "50px" : "40px" }}
                  >
                    <i
                      style={{ color: "#818389" }}
                      className="flaticon-search"
                    ></i>
                  </Button>
                </InputGroupAddon>
              </InputGroup>
            </span>
          </Col>
        </Row>
        {/* <Row className="mlmr0 mt10"><Col><div className="officemates-hr-line"></div></Col></Row> */}
        <div className="mt30">
          {this.state.displayUsers.length > 0 ? (
            this.state.displayUsers.map((officeMate, index) => {
              return (
                <OfficeMate
                  key={officeMate._id}
                  officeMate={officeMate}
                  userRole={this.props.user.role}
                  user={this.props.user}
                  onRoleChange={this.handleRoleChange}
                  onOfficeChange={this.handleOfficeChange}
                  allOfficesWithInvitations={
                    this.state.allOfficesWithInvitations
                  }
                  onUserRemoved={() => this.handleUserRemoved(officeMate._id)}
                  rowIndex={index}
                  {...this.props}
                />
              );
            })
          ) : (
            <EmptyTable
              title="No results found"
              subtitle="Try rephrasing your search to find users in your enterprise"
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.profile,
  };
};

export default connect(mapStateToProps)(Loading(withRouter(UsersList), axios));
